import PropTypes from 'prop-types'
import { Box } from '@redriverpress/system'

const lineStyles = {
  done: {
    backgroundColor: 'blue500',
  },
}

export default function Divider({ variant }) {
  return (
    <Box px={1} display={['none', null, 'flex']} alignItems='baseline'>
      <Box
        height={2}
        width={80}
        backgroundColor='gray150'
        {...lineStyles[variant]}
      />
      <Box>&nbsp;</Box>
    </Box>
  )
}

Divider.defaultProps = {
  variant: 'default',
}

Divider.propTypes = {
  variant: PropTypes.oneOf(['default', 'done', 'active']),
}
